import { render, staticRenderFns } from "./EtapaConjunto.vue?vue&type=template&id=72557508"
import script from "./EtapaConjunto.vue?vue&type=script&lang=js"
export * from "./EtapaConjunto.vue?vue&type=script&lang=js"
import style0 from "./EtapaConjunto.vue?vue&type=style&index=0&id=72557508&prod&lang=scss"
import style1 from "./EtapaConjunto.vue?vue&type=style&index=1&id=72557508&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports